import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v6/products/zoneticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const createOrder = function(
    passengers,
    startZoneNumber,
    viaZoneNumber,
    endZoneNumber,
    startStopId,
    viaStopId,
    endStopId,
    validFromInstant,
    ownerHandlesFailure
) {
    let requestData = {
        salesChannelIdentifier: "Webshop",
        Passengers: passengers,
        StartZoneNumber: startZoneNumber,
        ViaZoneNumber: viaZoneNumber,
        EndZoneNumber: endZoneNumber,
        StartStopId: startStopId,
        ViaStopId: viaStopId,
        EndStopId: endStopId,
        ValidFromInstant: validFromInstant
    };

    return callApi(
        "POST",
        "v3/products/zoneticket/order",
        requestData,
        ownerHandlesFailure
    );
};
